import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { services } from '../../apis';

const getupcomingLiveModule = (modules: any, globalVariables: any) => {
	// const cur_date = globalVariables.curr_date;
	for (let i = 0; i < modules.length; i++) {
		const module = modules[i];
		const todayLive =
			(new Date().toLocaleString('en-US') >=
				new Date(module.live_at).toLocaleString('en-US') &&
				new Date().getDate() == new Date(module.live_at).getDate() &&
				new Date().getHours() <= 23) ||
			new Date(module.live_at).toLocaleString('en-US') >=
				new Date().toLocaleString('en-US');
		if (todayLive) return module;
	}
	// return md[0]
};

export const fetchCourseInformation = createAsyncThunk(
	'precourse/fetchCourseInformation',
	async (_, thunkAPI) => {
		const state: any = thunkAPI.getState();
		const { globalVariables } = state.globals;
		try {
			if (globalVariables != null) {
				const data = await services.precourseService.fetchPrecourse();
				const tdmodule = getupcomingLiveModule(
					data.modules,
					globalVariables
				);
				return { data, tdmodule };
			}
		} catch (error) {
			console.log(error);
		}
	}
);

export const fetchCodingQuestions = createAsyncThunk(
	'precourse/fetchCodingQuestion',
	async (moduleId: string) => {
		try {
			return await services.codingQuestionService.getCodingQuestionsForModule(
				moduleId
			);
		} catch (error) {
			console.log(error);
		}
	}
);

export const getStreak = createAsyncThunk('users/streak', async () => {
	try {
		// return await services.userService.getStreak();
		return;
	} catch (error) {
		console.log(error);
	}
});

interface PrecourseState {
	courseData: any;
	variableData: any;
	codingQuestiondata: any;
	streak: number;
	totAssignments: number;
	solvedAssignments: number;
	upcomingLiveModule: any;
	// extra
	loading: boolean;
	error: {
		state: boolean;
		message: string;
	};
}

const initialState: PrecourseState = {
	courseData: undefined,
	variableData: undefined,
	codingQuestiondata: undefined,
	upcomingLiveModule: undefined,
	streak: 0,
	totAssignments: 0,
	solvedAssignments: 0,
	// extra
	loading: false,
	error: {
		state: false,
		message: '',
	},
};

export const precourseSlice = createSlice({
	name: 'precourse',
	initialState,
	reducers: {
		setOrientationComplete: (state, action: PayloadAction<any>) => {
			state.courseData.enrollment.isOrientationCompleted = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
	},
	extraReducers: {
		//@ts-ignore
		[fetchCourseInformation.pending]: (
			state: PrecourseState,
			action: PayloadAction<any>
		) => {
			state.loading = true;
		},
		//@ts-ignore
		[fetchCourseInformation.fulfilled]: (
			state: PrecourseState,
			action: PayloadAction<any>
		) => {
			state.loading = false;
			state.courseData = action.payload.data;
			const modules = action.payload.data.modules;
			let totass = 0;
			let solvedass = 0;
			modules.map((sn: any) => {
				totass += sn.totalQuestionsInThisModule;
				solvedass += sn.completeQuestionInThisModule;
			});
			state.upcomingLiveModule = action.payload.tdmodule;
			state.totAssignments = totass;
			state.solvedAssignments = solvedass;
			state.error.state = false;
			state.error.message = '';
		},
		//@ts-ignore
		[fetchCourseInformation.rejected]: (
			state: PrecourseState,
			action: PayloadAction<any>
		) => {
			state.loading = false;
			state.error.state = true;
			state.error.message = 'Error, please try again later';
		},
		//@ts-ignore
		[fetchCodingQuestions.pending]: (
			state: PrecourseState,
			action: PayloadAction<any>
		) => {
			state.loading = true;
		},
		//@ts-ignore
		[fetchCodingQuestions.fulfilled]: (
			state: PrecourseState,
			action: PayloadAction<any>
		) => {
			state.loading = false;
			state.codingQuestiondata = action.payload;
		},
		//@ts-ignore
		[getStreak.pending]: (
			state: PrecourseState,
			action: PayloadAction<any>
		) => {
			state.loading = true;
		},
		//@ts-ignore
		[getStreak.fulfilled]: (
			state: PrecourseState,
			action: PayloadAction<any>
		) => {
			state.loading = false;
			state.streak = action.payload;
		},
	},
});

//Exporting Actions
export const { setOrientationComplete, setLoading } = precourseSlice.actions;
export default precourseSlice.reducer;
